import React, { useContext, useEffect, useState } from "react";
import CustomSpinner from "../../../../../components/CustomSpinner";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import {
  downloadStudyPPT,
  downloadStudyZip,
  _base64ToArrayBuffer,
  fetchDownloadProgress,
  downloadCompletedFile,
  startDownloadingZip,
  startDownloadingPpt,
} from "../../../../../service/StudyViewerService";
import DownloadImageModal from "./DownloadImageModal";
import toastContext from "../../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../../constants/Constants";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";

const DownloadOptions = ({
  option,
  setShowDropDown,
  index,
  setLoadingState,
  showOption,
  setHoveredParent
}) => {
  const [hovered, setHovered] = useState(false);
  const { username } = useContext(userContext);
  const [downloadImageModal, setDownloadImageModal] = useState(false);
  const {
    showToastv2,
    showProgressToast,
    setProgressList,
    progressList,
    updateProgress,
    hideProgress,
  } = useContext(toastContext);
  const handleMouseOver = () => {
    if (showOption && !isChildStudyActive) {
      setHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (showOption && !isChildStudyActive) {
      setHovered(false);
    }
  };

  const handleDownloadClick = async () => {
    if (showOption && !isChildStudyActive) {
      setHoveredParent(false);
      if (index === 0) {
        await handleStudyDownloadZip();
        logAmplitudeEventWithUsernameAndRole(
          "EVENT_BASIC_DOWNLOAD_STUDY_USED",
          {},
          username
        );
      } else if (index === 1) {
        await handleStudyDownlaodPPT();
      } else if (index === 2) {
        setDownloadImageModal(true);
      }
    }
    // setShowDropDown(false);
  };

  const { studyParentId, studyData, setShowToast } =
    useContext(studyviewerContext);
  const { activeThumbnailIndex } = useContext(ThumbnailContext);
  const { isChildStudyActive } = useContext(ViewportContext);

  const [studyZipProgress, setStudyZipProgress] = useState(0);
  const [studyZipProgressId, setStudyZipProgressId] = useState(0);
  const [studyPptProgress, setStudyPptProgress] = useState(0);
  const [studyPptProgressId, setStudyPptProgressId] = useState(0);
  const [zipToken, setZipToken] = useState("");
  const [zipFetchInterval, setZipFetchInterval] = useState(0);
  const [pptToken, setPptToken] = useState("");
  const [pptFetchInterval, setPptFetchInterval] = useState(0);

  useEffect(() => {
    if (studyZipProgress === 0) return;
    // updateProgressList(1, studyZipProgress);

    if (studyZipProgress < 90) {
      // const updatedProgressIndex = progressList.findIndex(
      //   (p) => p.id === studyZipProgressId
      // );
      // const updatedProgress = progressList[updatedProgressIndex];
      // updatedProgress.progress = studyZipProgress;
      // const newProgressList = [...progressList];
      // newProgressList[updatedProgressIndex] = updatedProgress;
      // setProgressList(newProgressList);
      updateProgress(studyZipProgressId, studyZipProgress);
      const oldProgress = studyZipProgress;
      let progress;
      const zipProgressInterval = setInterval(async () => {
        progress = await fetchZipDownloaddProgress(zipProgressInterval);
        if (progress > oldProgress) {
          clearInterval(zipProgressInterval);
        }
      }, zipFetchInterval);
    }

    if (studyZipProgress === 90) {
      updateProgress(studyZipProgressId, studyZipProgress);
      downloadFile(zipToken, true);
    }

    if (studyZipProgress === 100) {
      updateProgress(studyZipProgressId, studyZipProgress);
      setTimeout(() => {
        hideProgress(studyZipProgressId);
        setStudyZipProgress(0);
      }, 3000);
    }
  }, [studyZipProgress]);

  useEffect(() => {
    if (studyPptProgress === 0) return;
    // updateProgressList(1, studyZipProgress);

    if (studyPptProgress < 90) {
      //
      updateProgress(studyPptProgressId, studyPptProgress);
      const oldProgress = studyPptProgress;
      let progress;
      const pptProgressInterval = setInterval(async () => {
        progress = await fetchPptDownloaddProgress(pptProgressInterval);
        if (progress > oldProgress) {
          clearInterval(pptProgressInterval);
        }
      }, pptFetchInterval);
    }

    if (studyPptProgress === 90) {
      updateProgress(studyPptProgressId, studyPptProgress);
      downloadFile(pptToken, false);
    }

    if (studyPptProgress === 100) {
      updateProgress(studyPptProgressId, studyPptProgress);
      setTimeout(() => {
        hideProgress(studyPptProgressId);
        setStudyPptProgress(0);
      }, 3000);
    }
  }, [studyPptProgress]);

  useEffect(() => {
    let progress;
    if (zipToken !== "") {
      const zipProgressInterval = setInterval(async () => {
        progress = await fetchZipDownloaddProgress(zipProgressInterval);
        if (progress > 0) {
          clearInterval(zipProgressInterval);
        }
      }, zipFetchInterval);
    }
  }, [zipToken]);

  useEffect(() => {
    let progress;
    if (pptToken !== "") {
      const pptProgressInterval = setInterval(async () => {
        progress = await fetchPptDownloaddProgress(pptProgressInterval);
        if (progress > 0) {
          clearInterval(pptProgressInterval);
        }
      }, pptFetchInterval);
    }
  }, [pptToken]);

  const fetchZipDownloaddProgress = async (zipProgressInterval) => {
    const response = await fetchDownloadProgress(zipToken);
    if (response.status === 200) {
      if (response.data.data.status === "FAILED") {
        hideProgress(studyZipProgressId);
        setStudyZipProgress(0);
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.data.error
            ? response.data.data.error
            : "Failed to download file."
        );
        clearInterval(zipProgressInterval)
        return;
      }
      if (response.data.data.progress === 100) {
        setStudyZipProgress(90);
      } else {
        setStudyZipProgress(response.data.data.progress);
      }
    }
    return response.data.data.progress;
  };

  const fetchPptDownloaddProgress = async (pptProgressInterval) => {
    const response = await fetchDownloadProgress(pptToken);
    if (response.status === 200) {
      if (response.data.data.status === "FAILED") {
        hideProgress(studyPptProgressId);
        setStudyPptProgress(0);
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.data.error
            ? response.data.data.error
            : "Failed to download file."
        );
        clearInterval(pptProgressInterval);
        return;
      }
      if (response.data.data.progress === 100) {
        setStudyPptProgress(90);
      } else {
        setStudyPptProgress(response.data.data.progress);
      }
    }
    return response.data.data.progress;
  };

  const getFileName = (response) => {
    var disposition = response.headers["content-disposition"];
    console.log(disposition);
    var filename = "demo.zip";
    if (disposition && disposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
    return filename;
  };

  const downloadFile = async (token, isZip) => {
    const response = await downloadCompletedFile(token);
    console.log(response);
    if (response.status === 200) {
      console.log(response.headers);

      // const fileData = _base64ToArrayBuffer(response.data.data);
      console.log(response.data);
      const file = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      // link.download = getFileName(response);
      link.setAttribute("download", getFileName(response));
      document.body.appendChild(link);
      link.click();
      if (isZip) {
        showToastv2(TOAST_TYPE.SUCCESS, "Study downloaded");
        setStudyZipProgress(100);
      } else {
        showToastv2(TOAST_TYPE.SUCCESS, "PPT downloaded");
        setStudyPptProgress(100);
      }
      link.remove();
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Error while downloading study.");
    }
  };

  const handleStudyDownloadZip = async () => {
    // setLoadingState(true);

    if (studyZipProgress > 0 && studyZipProgress < 100) {
      showToastv2(TOAST_TYPE.INFO, "You zip is getting download. Please wait");
      return;
    }

    const id = showProgressToast("Downloading zip", studyZipProgress);
    setStudyZipProgressId(id);
    // setStudyZipProgress(5);
    const response = await startDownloadingZip(studyParentId);
    console.log(response);
    if (response.status === 201) {
      setZipToken(response.data.data.token);
      setZipFetchInterval(getFetchInterval(response.data.data.imageCount));
      showToastv2(TOAST_TYPE.INFO, "Downloading started");
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Failed to start downloading");
      hideProgress(studyZipProgressId);
    }
  };

  const handleStudyDownlaodPPT = async () => {
    if (studyPptProgress > 0 && studyPptProgress < 100) {
      showToastv2(TOAST_TYPE.INFO, "You ppt is getting download. Please wait");
      return;
    } // setLoadingState(true);

    const id = showProgressToast("Study Ppt", studyZipProgress);
    setStudyPptProgressId(id);
    // setStudyPptProgress(5);
    const response = await startDownloadingPpt(
      studyParentId,
      studyData.stacks[activeThumbnailIndex].stackId
    );
    if (response.status === 201) {
      setPptToken(response.data.data.token);
      setPptFetchInterval(getFetchInterval(response.data.data.imageCount));
      showToastv2(TOAST_TYPE.INFO, "Downloading PPT");
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Failed to start downloading");
      hideProgress(studyPptProgressId);
    }
  };

  const getFetchInterval = (imageCount) => {
    if (imageCount > 0 && imageCount <= 10) return 1000;
    else if (imageCount > 10 && imageCount <= 100) return 2000;
    else if (imageCount > 100 && imageCount <= 300) return 3000;
    else if (imageCount > 300 && imageCount <= 500) return 4000;
    else return 5000;
  };

  return (
    <>
      {/* {loadingState && <CustomSpinner />} */}
      <div
        className="viewer-download-button"
        style={{
          display: "flex",
          alignItems: "center",
          height: "40px",
          // color: `${hovered ? "#0085FF" : "white"}`,
          cursor: `${!isChildStudyActive ? "pointer" : "not-allowed"}`,
        }}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onClick={handleDownloadClick}
      >
        {option}
      </div>
      {downloadImageModal && (
        <DownloadImageModal
          downloadImageModal={downloadImageModal}
          setDownloadImageModal={setDownloadImageModal}
        />
      )}
    </>
  );
};

export default DownloadOptions;
